
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { Booking } from '@/bookings/interfaces';
import { formatShortDate, formatTime, formatDateChoice} from '@/core/tools';

import BaseBooking from './BaseBooking.vue';
import CancelBooking from './CancelBooking.vue';

    @Component({components:{CancelBooking}})
    export default class BookingUser extends BaseBooking {

        @Prop() data!: Booking[]; 

        @Prop() mybooking!: boolean;

        @Getter('currentBooking', {namespace: 'booking'}) currentBooking!: Booking;

        @Getter('response', {namespace: 'booking'}) response!: boolean;


        statusVisible = false;

        bookingToDelete :Booking | null = null;

        bookingId : string[] = [];

        deleteBookingModal = false;

        selectedBook: number | null = null

        getFormatTime = function getFormatDate(date: string): string {
      return formatTime(date);
    };

        formatDate(date: string):string{
            const shortDate =  formatShortDate(date)
            return `${shortDate[1]} ${shortDate[0]}`
        }

        formatDateChoice(date: string, format : string):string{
            return formatDateChoice(date, format)
        }

        parseTime(date: string):string{
            return date
        }

        sendBooking(booking : Booking):void{            
            this.$route.params.id = booking._id || ''
    }

    sortDate (dateA:string, dateB:string): number {
    return parseInt(dateA.slice(0, 10).split('-').join(''),10) - parseInt(dateB.slice(0, 10).split('-').join(''), 10);
  }

  deleteModal(bookingId : string, event : Event ){
    event.stopPropagation()

    this.getBooking(bookingId)
    this.deleteBookingModal = true
    
  }

  bugHere(){
    console.log('closeAll')
  }



  animationSatus(index: number){

    if (this.selectedBook === index){
        this.selectedBook = null
    }
    else {
        this.selectedBook = index
    }

  }

}

